import api from '../store/apiClient';

function withLocale(params = {}, locale) {
  const out = { ...params };
  if (locale && String(locale).trim()) out.locale = String(locale).trim();
  return out;
}

export async function getPosts(params = {}, locale) {
  const { data } = await api.get('/blog', { params: withLocale(params, locale) });
  return data;
}

export async function getPostBySlug(slug, locale) {
  const { data } = await api.get(`/blog/${encodeURIComponent(slug)}`, {
    params: withLocale({}, locale),
  });
  return data;
}

export async function getBlogTags(locale) {
  const { data } = await api.get('/blog/tags', { params: withLocale({}, locale) });
  return data;
}

export async function getRelatedPosts(slug, locale, limit = 4) {
  const { data } = await api.get('/blog/related', {
    params: withLocale({ slug, limit }, locale),
  });
  return data;
}

export async function getPrevNext(slug, locale) {
  const { data } = await api.get('/blog/prev-next', {
    params: withLocale({ slug }, locale),
  });
  return data;
}

/** @param {unknown} body */
export function normalizePostsList(body) {
  if (Array.isArray(body?.data)) return body.data;
  if (Array.isArray(body?.posts)) return body.posts;
  if (Array.isArray(body)) return body;
  return [];
}

/** @param {unknown} body */
export function normalizePost(body) {
  return body?.data ?? body?.post ?? body ?? null;
}

/** @param {unknown} body */
export function normalizeTags(body) {
  if (Array.isArray(body?.data)) return body.data;
  if (Array.isArray(body)) return body;
  return [];
}

/** @param {unknown} body */
export function normalizeRelated(body) {
  if (Array.isArray(body?.data)) return body.data;
  if (Array.isArray(body)) return body;
  return [];
}

/** @param {unknown} body */
export function normalizePrevNext(body) {
  const payload = body?.data ?? body ?? {};
  return {
    prev: payload.prev ?? null,
    next: payload.next ?? null,
  };
}
